import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class EmailDomain extends ApplicationRecord {
  static jsonapiType = "email_domains";

  @Attr() name: string;

  @Attr() companyId: number;
}

export default EmailDomain;
